import React, { Dispatch, SetStateAction } from "react";
import Modal, { Body, Footer, Header } from "~/common/ModalReact";
interface Props {
  modalOpen: boolean;
  setModalOpen: Dispatch<SetStateAction<boolean>>;
  cartLimitMessage: string;
}
export default ({
  modalOpen,
  setModalOpen,
  cartLimitMessage
}: Props) => {
  return <Modal isOpen={modalOpen} onRequestClose={() => setModalOpen(false)} className="w-11/12 modal--md">
      <Header closeModal={() => setModalOpen(false)} className="text-sm font-bold">
        Cart Limit Reached
      </Header>
      <Body className="text-sm font-normal">
        <p>{cartLimitMessage}</p>
      </Body>
      <Footer>
        <button type="button" className="btn btn-light btn-close" onClick={() => setModalOpen(false)}>
          Close
        </button>
      </Footer>
    </Modal>;
};